module.exports = __webpack_public_path__ + "img/pic_21s.4fd336a7.jpg";